import { render, staticRenderFns } from "./IbanEdit.vue?vue&type=template&id=0ff2926c"
import script from "./IbanEdit.vue?vue&type=script&lang=ts"
export * from "./IbanEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports